import { formatResealedFilters, makeResealedToolbar } from "@lib/filterUtil";
import { isServer } from "@lib/helpers";

import {
  GET_CATEGORY_RESEALED_TREE,
  GET_CATEGORY_RESEALED_TREE_SUCCESS,
  GET_CATEGORY_RESEALED_TREE_FAILURE,
  GET_CATEGORY_RESEALED_TREE_CACHE_SUCCESS,
  GET_CATEGORY_RESEALED,
  GET_CATEGORY_RESEALED_SUCCESS,
  GET_CATEGORY_RESEALED_FAILURE,
} from "@store/resealed/constants";

import { makeApiCall } from "@lib/api/helpers";
import { getCategoryTreeResealedApi, getCategoryResealedApi } from "@lib/api";

export const getCategoryResealedTree = () => async (dispatch, getState) => {
  const date = new Date();
  const timestamp = date.getTime();
  const cacheTime = 5 * 60 * 1000; // minutes * seconds * milliseconds

  if (isServer) {
    if (
      global?.resealed?.tree &&
      global?.resealed?.treeLastUpdatedAt &&
      timestamp - global.resealed.treeLastUpdatedAt < cacheTime
    ) {
      return dispatch({
        type: GET_CATEGORY_RESEALED_TREE_SUCCESS,
        payload: global.resealed.tree,
      });
    }
  }

  if (!isServer) {
    const tree = getState().resealed.tree;
    const treeLastUpdatedAt = getState().resealed.treeLastUpdatedAt;

    if (
      tree &&
      treeLastUpdatedAt &&
      timestamp - treeLastUpdatedAt < cacheTime
    ) {
      return dispatch({
        type: GET_CATEGORY_RESEALED_TREE_CACHE_SUCCESS,
      });
    }
  }

  return makeApiCall({
    actions: {
      action: GET_CATEGORY_RESEALED_TREE,
      success: GET_CATEGORY_RESEALED_TREE_SUCCESS,
      fail: GET_CATEGORY_RESEALED_TREE_FAILURE,
    },
    dispatch,
    getState,
    spinner: false,
    alert: true,
    alertMessage: `Get resealed category tree couldn't be completed...`,
    apiCall: getCategoryTreeResealedApi,
    formatResponse: (response) => response.data,
    postSuccess: (response) => {
      if (isServer && global) {
        const date = new Date();
        const timestamp = date.getTime();

        global.resealed = {
          tree: response.data,
          treeLastUpdatedAt: timestamp,
        };
      }
    },
  });
};

export const getCategoryResealed =
  (query, extractedFiltersParams) => (dispatch, getState) => {
    const urlPath = query.urlKey;
    const apiArgs = [
      urlPath ? encodeURIComponent(urlPath) : "",
      extractedFiltersParams.apiQueryParams,
    ];

    return makeApiCall({
      actions: {
        action: GET_CATEGORY_RESEALED,
        success: GET_CATEGORY_RESEALED_SUCCESS,
        fail: GET_CATEGORY_RESEALED_FAILURE,
      },
      dispatch,
      getState,
      spinner: false,
      alert: true,
      apiCall: getCategoryResealedApi,
      apiArgs,
      returnResponse: true,
      formatResponse: (response) => {
        const { data } = response;

        if (data.layeredNavigation?.length > 0) {
          const priceIndex = data.layeredNavigation.findIndex(
            (p) => p.attribute_code === "price"
          );

          data.layeredNavigation[priceIndex].filters.forEach((filter) => {
            filter.slug = filter.slug.replace("_", "-");
          });
        }

        const res = {
          data,
          urlPath,
        };

        if (res.data.breadcrumbs) {
          res.data.breadcrumbs.forEach((breadcrumb) => {
            if (breadcrumb.url_key) {
              breadcrumb.url_key = `resigilate/${breadcrumb.url_key}`;
              breadcrumb.url_suffix = "/cpl/";
            }
          });

          // Push at the beginning the default route in breadcrumbs
          res.data.breadcrumbs.unshift({
            name: "Produse resigilate",
            url_key: "resigilate/",
            id: 1,
            level: res.data.breadcrumbs.length === 0 ? 99 : 1,
          });
        }

        const { filters, activeFilters } = formatResealedFilters(
          data.layeredNavigation,
          extractedFiltersParams,
          "category",
          query
        );

        const toolbar = makeResealedToolbar(
          data.meta,
          "category",
          extractedFiltersParams,
          query
        );

        res.data.filters = filters;
        res.data.activeFilters = activeFilters;
        res.data.toolbar = toolbar;
        res.extractedFiltersParams = extractedFiltersParams;

        return res;
      },
    });
  };
